var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCassetteGoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.45915V12.7H16V3.45915H0ZM0 2.74078H16V0.299988H0V2.74078ZM4.2082 9.61642C5.24216 9.61642 6.08035 8.77823 6.08035 7.74427C6.08035 6.71031 5.24216 5.87212 4.2082 5.87212C3.17424 5.87212 2.33604 6.71031 2.33604 7.74427C2.33604 8.77823 3.17424 9.61642 4.2082 9.61642ZM13.664 7.74427C13.664 8.77823 12.8258 9.61642 11.7918 9.61642C10.7579 9.61642 9.91966 8.77823 9.91966 7.74427C9.91966 6.71031 10.7579 5.87212 11.7918 5.87212C12.8258 5.87212 13.664 6.71031 13.664 7.74427Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCassetteGoods);
export default __webpack_public_path__ + "static/media/cassetteGoods.3a2f1a52ac7928f19dd97f2a3e2fdc11.svg";
export { ForwardRef as ReactComponent };